import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface DatatypeHistoryMaintenance {
  type: string
  title: string
  info: Info
}

export interface Info {
  type: string
  bks: string
  vin: string
  carId: string
  id: string
  maintenanceDay: string
  finishDay: string
}
export interface ICarCompany {
  id: number
  title: string
  image: string
}

export interface IHistory {
  id: number
  dateTransaction: string
  customerId: number
  userName: string
  typeInteractionId: number
  typeInteractionName: string
  careAndFeedbackId?: number
  careAndFeedbackIdTitle?: string
  nameStaff?: string
  typeSupportTitle?: string
  carId?: number
  carCode?: string
  carName?: string
  agentId?: number
  agentName?: string
}
export interface IHistoryCarDetail {
  id: number
  customerId: number
  userName: string
  agentId: number
  agentName: string
  codeContract: string
  numberContract: string
  dateTransaction: string
  carId: number
  carCode: string
  carName: string
  carImage: string
  fuelId: number
  fuel: string
  segmentsVehicleId: number
  segmentsVehicle: string
  colorId: number
  color: string
  modelVehicleId: number
  modelVehicle: string
  typeBodyVehicleId: number
  typeBodyVehicle: string
  categoryCarId: number
  categoryCarName: string
  categoryCarImage: string
  countryId: number
  countryName: string
  countryImage: string
  VIN: string
  engineNumber: string
}

export interface IHistoryMaintenance {
  id: number
  carId: number
  carCode: string
  carName: string
  BKS: string
  VIN: string
  codeMaintenance: string
  kmNearest: number
  warrantyPeriod: number
  dateMaintenance: string
  dateComplete: string
  typeInteractionId: number
  typeInteractionName: string
}

export interface IHistoryMaintenance_V2 {
  id: number
  BKS: string
  VIN: string
  codeMaintenance: any
  kmNearest: number
  warrantyPeriod: any
  dateMaintenance: string
  dateComplete: string
}

export interface IHistoryCarInUse {
  id: number,
  yearManufacture: string,
  VIN: string,
  datePurchaseCar: string,
  datePickUpCar: string,
  categoryCar: string,
  categoryCarImage: string,
  carLines: string,
  carName: string,
  carImage: string
  typeCar: string
}
export interface data {
  id: number
  title: string
}
export interface ICarInterested {
  id: number
  categoryCar: ICarCompany
  car: ICarCompany
  carLine: data
  typeVehicle: data
}

export type CarStatus = 0 | 1;

export const CarInUseHistory: CarStatus = 0;
export const CarOwnerShip: CarStatus = 1;
export interface IHistoryPurchase {
  id: number
  invoiceNumber: string
  srCode: string
  quantity: number
  quantityDKDV: number
  paymentMethod: string
  chassisNumber?: string
  currentKM?: string
  gtdtDate: string
  dnshDate: string
  exportDate: string
  userUser?: string
}

export interface IFilter {
  date?: string[];
  search?: string
}

// danh sách lịch sử xe đang sử dụng
export const gLisCarInUseHistory = async (
  type: CarStatus,
  limit?: number, pageNumber?: number, customerId?: number,
) => {
  const params = {
    limit, pageNumber, customerId, type
  }
  const path = 'HistoryCarCustomer/listHistoryCustomer'
  const result: ResponseSuccessTotal<IHistoryCarInUse[]> = await axiosClient.get(
    path, { params }
  )
  return result
}
// danh sách lịch sử xe quan tâm
export const gLisCarInterested = async (
  limit?: number, pageNumber?: number, customerId?: number,
) => {
  const params = {
    limit, pageNumber, customerId
  }
  const path = 'interestedCarCustomer/listInterestedCar'
  const result: ResponseSuccessTotal<ICarInterested[]> = await axiosClient.get(
    path, { params }
  )
  return result
}

export const getListHistoryMaintenance = async (
  limit?: number, pageNumber?: number, customerId?: string, carId?: string,
) => {
  const params = {
    customerId, carId, limit, pageNumber
  }
  const path = "history/listHistoryMaintenance"
  const result: ResponseSuccessTotal<IHistoryMaintenance[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListHistoryMaintenance_V2 = async (
  limit?: number, pageNumber?: number, customerId?: number, carId?: string, timeStart?: string, timeEnd?: string
) => {
  const params = {
    customerId, carId, limit, pageNumber, timeStart, timeEnd
  }
  const path = "history/listHistoryMaintenance"
  const result: ResponseSuccessTotal<IHistoryMaintenance_V2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Danh sách lịch sử
export const getListHistory = async (
  customerId?: number, pageNumber?: number, limit?: number, searchName?: string, timeStart?: string, timeEnd?: string, interactionTypeId?: number,
) => {
  const params = {
    customerId, pageNumber, limit, searchName, timeStart, timeEnd, interactionTypeId
  }
  const path = "history/listHistory"
  const result: ResponseSuccessTotal<IHistory[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin lịch sử xe sở hữu
export const getListHistoryCarInfo = async (historyId: number,
) => {
  const params = {
    historyId
  }
  const path = "history/historyCarInfo"
  const result: ResponseSuccess<IHistoryCarDetail> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Danh sách lịch sử mua hàng
export const getListHistoryPurchase = async (customerId: number, search?: string, timeStart?: string, timeEnd?: string
) => {
  const params = {
    customerId, search, timeStart, timeEnd
  }
  const path = "history/listHistoryPurchase"
  const result: ResponseSuccess<IHistoryPurchase[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Thông tin lịch sử xe sở hữu
export const gInfoHistoryPurchase = async (historyPurchaseId: number, customerId: number
) => {
  const params = {
    customerId,
    historyPurchaseId
  }
  const path = "history/historyPurchaseInfo"
  const result: ResponseSuccess<IHistoryPurchase> = await axiosClient.get(
    path, { params }
  );
  return result;
};
